export default __webpack_public_path__ + "dist/media/Menu-bar.0f3a34d1.svg";